import React from 'react';
import {observer} from 'mobx-react';
import {List, InputItem, Button, Toast} from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css';
import {Form} from "antd";
import store from './store'

@observer
class StudentSearchCoin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    }
  }

  showToast = (data) => {
    Toast.info(data, 2);
  };

  handleSearch = () => {
    this.props.form.validateFields({force: true}, (error) => {
      if (!error) {
        let student_data = this.props.form.getFieldsValue();
        if (!student_data['mobile']) {
          this.showToast('手机号不能为空！');
          return;
        }
        store.searchStuCoin(student_data);
        console.log('student_data', student_data);
      }
    });
  };


  render() {
    const {getFieldProps} = this.props.form;
    return (<form>
        <div>
          <List.Item>
            <div style={{width: '100%',  fontSize: '28px', textAlign: 'center'}}>
              学员积分查询
            </div>
          </List.Item>
          <List>
            <InputItem
              {...getFieldProps('mobile')}
              title="手机"
              type="phone"
              placeholder="请输入手机">手机
            </InputItem>
            <div style={{marginTop: "10px", marginBottom: "10px"}}>
              <span><b>【积分说明】</b></span>
              <span>积分是马哥教育针对老学员推出的增值服务，用于兑换马哥教育礼品或者课程使用。</span>
              <span>激活个人积分功能，请联系班主任或者QQ295813080</span>
            </div>
            <div>
              <Button type="primary" loading={this.state.loading} onClick={this.handleSearch}>查询</Button>
            </div>
          </List>
        </div>
      </form>
    );
  }
}

export default Form.create()(StudentSearchCoin)
